import { GetToken, GuestLogin, Me, SetToken, SetUser, UpdateToken } from '../services/Session';

export async function handleRefresh(callBack, retryCountRef, isGuestAllowed, setUser) {
	retryCountRef.current++;
	if (retryCountRef.current < 5) {
		if (GetToken().refresh_token) {
			try {
				const { data } = await UpdateToken();
				handleRetry(data.token, callBack, setUser);
			} catch {
				if (isGuestAllowed) {
					const { data } = await GuestLogin();
					handleRetry(data.token, callBack, setUser);
				}
			}
		} else if (isGuestAllowed) {
			const { data } = await GuestLogin();
			handleRetry(data.token, callBack, setUser);
		}
	}
};

export async function handleRetry(token, cb, setUser) {
	try {
		const { data } = await Me(SetToken(token).access_token);
		if (setUser!=undefined) {
			setUser(data);
		}
		SetUser(data);
		setTimeout(cb, 1e3);
	} catch {}
};

export async function handleError(err, funcName, retryCountRef, isGuestAllowed, setUser) {
	if (err.response) {
		if (err.response.status === 401) {
			handleRefresh(funcName, retryCountRef, isGuestAllowed, setUser);
		} else if (err.response.data?.error?.message) {
			alert(err.response.data.error.message);
		} else {
			alert('gagal terhubung ke server');
		}
	} else {
		alert('gagal terhubung ke server');
	}
};
